import Component from "vamos/cockpit/Component";
import ResourceModel from "sap/ui/model/resource/ResourceModel";
import ResourceBundle from "sap/base/i18n/ResourceBundle";

export default function getText(key: string, args: any[] = undefined): string {
  const model = Component.getComponent().getModel("i18n") as ResourceModel;
  const bundle = model.getResourceBundle() as ResourceBundle;
  return bundle.getText(key, args);
}
